var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"fce97220fc3d5a32ea5a222b9a6eeb7211bd2b7a"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://957dcee8deb4103167bb14e8a4a9cf2b@o4510829225050112.ingest.us.sentry.io/4510830666907648',
  tracesSampleRate: 0.1,

  beforeSend(event) {
    const message = event.message || event.exception?.values?.[0]?.value || '';

    if (message.includes("Iframe didn't loaded in 20000 ms")) {
      return null;
    }

    return event;
  }
});
